<template>
  <v-card variant="outlined" height="100%">
    <v-card-title>Реестры и списки</v-card-title>
    <v-list lines="two">
      <v-list-item
        title="ТОР Моя Школа"
        subtitle="Настроить и выгрузить данные в формате XLSX"
        prepend-icon="mdi-school-outline"
        append-icon="mdi-chevron-right"
        to="/export/torMySchool/"
      />
      <v-list-item
        v-for="link in links"
        :key="link.href"
        :href="link.href"
        :title="link.title"
        :subtitle="link.subtitle"
        :prepend-icon="link.icon"
        append-icon="mdi-open-in-new"
        target="_blank"
        rel="noopener noreferrer"
      />
    </v-list>
  </v-card>
</template>

<script>
export default {
  name: 'RegistersSection',
  props: {
    wwwroot: {
      type: String,
      required: true,
    },
  },
  computed: {
    links() {
      return [
        {
          title: 'Реестр на выпуск карт «Мир»',
          subtitle: 'Сбербанк / ВТБ',
          icon: 'mdi-credit-card-outline',
          href: `${this.wwwroot}/blocks/manage_groups/personal/export_mir.php`,
        },
        {
          title: 'Экспорт групп «Труд всем»',
          subtitle: 'Список групп для выгрузки',
          icon: 'mdi-account-group-outline',
          href: `${this.wwwroot}/blocks/manage_groups/personal/export_job.php`,
        },
      ];
    },
  },
};
</script>
